const namespace = 'Groups';

export const REQUEST_GROUPS = `${namespace}/REQUEST_GROUPS`;
export const RECEIVE_GROUPS_SUCCESS = `${namespace}/RECEIVE_GROUPS_SUCCESS`;
export const RECEIVE_GROUPS_FAILURE = `${namespace}/RECEIVE_GROUPS_FAILURE`;

export const REQUEST_SAVE_GROUP = `${namespace}/REQUEST_SAVE_GROUP`;
export const RECEIVE_SAVE_GROUP_SUCCESS = `${namespace}/RECEIVE_SAVE_GROUP_SUCCESS`;
export const RECEIVE_SAVE_GROUP_FAILURE = `${namespace}/RECEIVE_SAVE_GROUP_FAILURE`;
